import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c374b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "restock-tip"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/replenish/tip_icon.png",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_4 = { class: "sync-order-tabs-com" }
const _hoisted_5 = { class: "tabs-item-text" }
const _hoisted_6 = {
  key: 0,
  class: "num"
}
const _hoisted_7 = { class: "tabs-item-text" }
const _hoisted_8 = { class: "tabs-item-text-top" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/Client/CN.png",
  alt: ""
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "num"
}
const _hoisted_13 = {
  key: 0,
  class: "tabs-item-time"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/replenish/refresh_icon.png",
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "tabs-item-text" }
const _hoisted_16 = { class: "tabs-item-text-top" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/JP.png",
  alt: ""
}, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "num"
}
const _hoisted_19 = {
  key: 0,
  class: "tabs-item-time"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/replenish/refresh_icon.png",
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "tabs-item-text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_23 = {
  key: 2,
  class: "restock-sum"
}
const _hoisted_24 = { class: "text" }
const _hoisted_25 = { class: "sync-order-tool-content" }
const _hoisted_26 = { class: "content-title" }
const _hoisted_27 = { class: "content-item" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "content-item" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "detail" }

import { isJA, useRtfix, isJpPurchase } from '@/store'
import { t } from '@/plugins/i18n'
import { onMounted, ref, computed } from 'vue'
import { getRestockTotalNumberApi } from '@/apis/order'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ShopType } from '@/common/const'
import { QuestionFilled } from '@element-plus/icons-vue'
import dayjs from 'dayjs'
import { request } from '@/config/request/interceptors'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['waitPayCount', 'value', 'replenishQuantity', 'filterData'],
  emits: ['update:value'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const router = useRouter()


const changeTab = (v) => {
  emits('update:value', v)
  if ((isShowRestockTab.value || isOpenRelenish.value) && !isTiktok.value) {
    getCount()
  }
}
const store = useStore()
// 是否开启智能补货计划
const isOpenRelenish = computed(() => store.getters.shopReplenishInfo?.smartReplenishFlag === 1)
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK)
const isShowRestockTab = computed(() => replenishInfo.value?.jp.totalWaitReplenishQuantity > 0 || replenishInfo.value?.cn.totalWaitReplenishQuantity > 0)
const isShowBanner = computed(() => {
  if (props.value === '2') {
    return replenishInfo.value?.cn.totalWaitReplenishQuantity > 0
  }
  if (props.value === '3') {
    return replenishInfo.value?.jp.totalWaitReplenishQuantity > 0
  }
  return false
})
const replenishInfo: any = ref({
  jp: {
    totalWaitReplenishQuantity: 0,
    maxCreateTime: ''
  },
  cn: {
    totalWaitReplenishQuantity: 0,
    maxCreateTime: ''
  }
})
const getCount = async () => {
  await store.dispatch('status/setJpPurchase', {}, { root: true })
  getRestockTotalNumberApi({
    purchaseCountry: 'CN'
  }).then((res: any) => {
    replenishInfo.value.cn = res.data ?? {}
  })
  // if (isJpPurchase()) {
  getRestockTotalNumberApi({
    purchaseCountry: 'JP'
  }).then((res: any) => {
    replenishInfo.value.jp = res.data ?? {}
  })
  // }
}
onMounted(() => {
  getCount()
})
const jump = () => {
  if (props.value === '3') {
    router.push(useRtfix('purchaseManageList'))
    return
  }
  router.push(useRtfix('OrderList', { query: { platformOrderStatus: 2 } }))
}
const updateOrder = async () => {
  const { success } = await request.customer.customer.shopManualReplenish()
  if (success) {
    ElMessage.success(t('补货计划手动更新已提交，系统正在处理中，请稍后刷新页面查看结果'))
  }
}
expose({
  getCount
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isJA)() && _unref(isShowBanner))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (__props.value === '2')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('已为您自动生成最新补货订单, 合计待补货商品数X件，').replace('X', __props.value === '2' ?
        replenishInfo.value?.cn?.totalWaitReplenishQuantity
        ?? 0 : replenishInfo.value?.jp?.totalWaitReplenishQuantity ?? 0)), 1),
                _createElementVNode("a", {
                  class: "restock-tip-a",
                  onClick: jump
                }, _toDisplayString(_unref(t)('查看并支付待补货订单')) + ">", 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('已为您自动生成最新的采购计划，合计商品数10件，').replace('X', __props.value === '2' ? replenishInfo.value?.cn?.totalWaitReplenishQuantity
        ?? 0 : replenishInfo.value?.jp?.totalWaitReplenishQuantity ?? 0)), 1),
                _createElementVNode("a", {
                  class: "restock-tip-a",
                  onClick: jump
                }, _toDisplayString(_unref(t)('查看采购计划')) + ">", 1)
              ], 64)),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["tabs-item", { 'active': __props.value === '0' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('0')))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_unref(isOpenRelenish) ? '引き当て未取り込み' : _unref(t)('未下单')) + " ", 1),
          (__props.waitPayCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.waitPayCount), 1))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_unref(isOpenRelenish) || replenishInfo.value?.cn?.totalWaitReplenishQuantity)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["tabs-item", { 'active': __props.value === '2' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab('2')))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(t)('待补货')) + " ", 1),
                (_unref(isJpPurchase)())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                  : _createCommentVNode("", true),
                (_unref(isJpPurchase)())
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true),
                (_unref(isJpPurchase)())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('中国采购')), 1))
                  : _createCommentVNode("", true)
              ]),
              (replenishInfo.value?.cn?.totalWaitReplenishQuantity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString((replenishInfo.value?.cn?.totalWaitReplenishQuantity
            ?? 0) > 99 ? '99+' : replenishInfo.value?.cn?.totalWaitReplenishQuantity ?? 0), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(isOpenRelenish))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('更新时间')) + "：" + _toDisplayString(replenishInfo.value?.cn?.maxCreateTime ? _unref(dayjs)(replenishInfo.value?.cn?.maxCreateTime).add(1,
          'hours').format('YYYY-MM-DD HH:mm') : '-'), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_unref(isOpenRelenish) && _unref(isJpPurchase)() || replenishInfo.value?.jp?.totalWaitReplenishQuantity)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["tabs-item", { 'active': __props.value === '3' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab('3')))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createTextVNode(_toDisplayString(_unref(t)('待补货')) + " - ", 1),
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_unref(t)('日本采购')), 1)
              ]),
              (replenishInfo.value?.jp?.totalWaitReplenishQuantity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString((replenishInfo.value?.jp?.totalWaitReplenishQuantity
            ?? 0) > 99 ? '99+' : replenishInfo.value?.jp?.totalWaitReplenishQuantity ?? 0), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(isOpenRelenish))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('更新时间')) + "：" + _toDisplayString(replenishInfo.value?.jp?.maxCreateTime ? _unref(dayjs)(replenishInfo.value?.jp?.maxCreateTime).add(1,
          'hours').format('YYYY-MM-DD HH:mm') : '-'), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["tabs-item", { 'active': __props.value === '1' }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab('1')))
      }, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('已下单')), 1)
      ], 2),
      _hoisted_22,
      (__props.replenishQuantity?.waitReplenishQuantity && __props.filterData.productSku)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('合计待补货商品数：X件').replace('X', __props.replenishQuantity?.waitReplenishQuantity)), 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "bottom",
              "popper-class": "tool-tip-no-border sync-order-tool"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_unref(t)('需补货明细')) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top",
                      content: "これまでの「補充必要数」と「補充キャンセル数」の合計です。"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, {
                          color: "#999",
                          class: "cursor-pt"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_unref(t)('被取消需补货数')) + "： ", 1),
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        placement: "top",
                        content: "これまでに発生した、補充が必要な数量です。"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            color: "#999",
                            class: "cursor-pt"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(QuestionFilled))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(__props.replenishQuantity?.cancelReplenishQuantity), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createTextVNode(_toDisplayString(_unref(t)('历史需补货数')) + "： ", 1),
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        placement: "top",
                        content: "一度補充されたものの、不良品・未納品などの理由により無効となった数量です。"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            color: "#999",
                            class: "cursor-pt"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(QuestionFilled))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(__props.replenishQuantity?.historyReplenishQuantity), 1)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)('明细')) + ">", 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})